import * as React from "react";
import "../../style/fonts.css";
import "./logOut.css";
import logo from "../../icons/bildmarke_smokeless.svg";
import logo_word from "../../icons/wortmarke_smokeless.svg";
import translate from "../../translations/i18n";
import CtaButton from "../ctaButton/ctaButton";
import { Link } from "react-router-dom";
import { signOut } from "src/store/actions/authActions";
import { connect } from "react-redux";

export interface Props {
  signOut(): void;
  ownAuth: any;
  isOpen: boolean;
}

class LogOutPage extends React.Component<Props, any> {
  constructor(props) {
    super(props);
    this.redirectToShopPage = this.redirectToShopPage.bind(this);
  }

  redirectToShopPage() {
    window.location.href = "https://shop.smokeless.world/";
  }

  render() {
    if (!this.props.ownAuth.isEmpty) {
      return (
        <div className="LOG_OUT_CONT">
          <div className="LOGOUT_LOGO_CONT">
            <img src={logo} className={"LOGOUT_LOGO_ICON"} />
          </div>
          <div className="LOGOUT_LOGO_WORD">
            <img src={logo_word} />
          </div>
          <div className="LOGOUT_LINK_CONT">
            <div onClick={this.props.signOut}>
              <Link to="/register">
                <div className="TITLE_3">{translate("CTA_LOGOUT")}</div>
              </Link>
            </div>
          </div>
          <div className="DELETE_ACC_LINK">
            <Link to="/downloadUserData">
              <div className="TITLE_3">
                {translate("CTA_DOWNLOAD_USERDATA_MENU")}
              </div>
            </Link>
          </div>
          <div className="DELETE_ACC_LINK">
            <Link to="/deleteAccount">
              <div className="TITLE_3">{translate("CTA_DELETE_ACCOUNT")}</div>
            </Link>
          </div>
          <div className="LOGOUT_BTN_TITLE_CONT">
            <div className="SMALL_TEXT1">
              {translate("CTA_QUIT_SMOKING_TITLE")}
            </div>
          </div>
          <div className="LOGOUT_BTN_CONT" onClick={this.redirectToShopPage}>
            <CtaButton
              width={"280px"}
              text={translate("CTA_QUIT_SMOKING")}
              color={"blue"}
            />
          </div>
        </div>
      );
    } else return null;
  }
}

const mapStateToProps = (state) => {
  return {
    ownAuth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogOutPage);



// WEBPACK FOOTER //
// ./src/components/screens/logOut.tsx